export enum ApplicantUrlPage {
  XING = 'xing',
  LINKED_IN = 'linked-in',
}
export const applicantUrlPages = [
  [ApplicantUrlPage.XING, 'https://www.xing.com/profile/'],
  [ApplicantUrlPage.LINKED_IN, 'https://www.linkedin.com/in/'],
];
